import { FC, useState } from 'react';
import { isTablet } from 'react-device-detect';

import { Carousel } from 'componets/common';
import { PrimaryMarketItemPhotosModal } from '../PrimaryMarketItemPhotosModal';
import { PrimaryMarketPhotoItem } from '../PrimaryMarketPhotoItem';

import './index.scss';

export const PrimaryMarketItemPhotos: FC<{ images: string[] }> = ({ images }) => {
	const firstImage = images[0];
	const secondImage = images[1];
	const thirdImage = images[2];

	const [isOpen, setIsOpen] = useState(false);
	const [current, setCurrent] = useState(0);

	const isTwo = images.length > 1 && images.length < 3;
	const isOne = images.length === 1;
	const isThree = images.length > 2;

	const length = images.length;

	return (
		<div className="primaryItemImages">
			<div className="primaryItemImages__mobileWrapper">
				{isOne ? (
					<PrimaryMarketPhotoItem src={firstImage} isFirst isOne />
				) : (
					<Carousel length={length} current={current} onSetCurrent={setCurrent}>
						<div
							className="primaryItemImages__mobileWrapper"
							role="button"
							onClick={() => {
								if (isTablet) {
									setIsOpen(true);
								}
							}}
						>
							<PrimaryMarketPhotoItem
								src={images[current]}
								isFirst
								isOne
								isCarousel
								index={current + 1}
							/>
						</div>
					</Carousel>
				)}
			</div>

			<div className="primaryItemImages__desktopWrapper">
				<Carousel
					style={{ width: isTwo || isOne ? '100%' : 'calc(73.29% - 8px)' }}
					length={length}
					current={current}
					onSetCurrent={setCurrent}
				>
					<div
						className="primaryItemImages__photoDesktopCarousel"
						role="button"
						onClick={() => {
							setIsOpen(true);
						}}
					>
						<PrimaryMarketPhotoItem src={images[current]} isOne index={current + 1} isCarousel />
					</div>
				</Carousel>

				{isThree && (
					<div className="primaryItemImages__secondBlock">
						<div
							className="primaryItemImages__littleWrapper"
							role="button"
							onClick={() => {
								setIsOpen(true);
								setCurrent(1);
							}}
						>
							<PrimaryMarketPhotoItem src={secondImage} isLittle />
						</div>

						<div
							className="primaryItemImages__littleWrapper"
							role="button"
							onClick={() => {
								setIsOpen(true);
								setCurrent(2);
							}}
						>
							<PrimaryMarketPhotoItem src={thirdImage} isButton />
							{images.length !== 3 && <CountsBackground number={images.length - 2} />}
						</div>
					</div>
				)}
			</div>

			{isOpen && (
				<PrimaryMarketItemPhotosModal
					isOpen={isOpen}
					onClose={() => setIsOpen(false)}
					length={length}
					current={current}
					onSetCurrent={setCurrent}
					images={images}
				/>
			)}
		</div>
	);
};

const CountsBackground: FC<{ number: number }> = ({ number }) => {
	return <div className="primaryItemImages__counts"> + {number}</div>;
};
